import React, { Component } from 'react';

//Assets
import DownloadAndroidButton from '../assets/store-android.png';
import DownloadAIOSButton from '../assets/store-ios.png';
import DownloadHuaweiButton from '../assets/store-huawei.png';
import PlayFacebookButton from '../assets/store-facebook.png';
import PlayButton from '../assets/store-web.png';

class AppPageStores extends Component {
    openStore(url){
        window.open(url);
    }

    caseButtons(){
        let tag;

        switch(this.props.id){
            case "android":{
                tag= <img src={DownloadAndroidButton} alt="Get It On Google Play" onClick={() => this.openStore(this.props.url)} />;
                break;}
            case "ios":
                tag= <img src={DownloadAIOSButton} alt="Download On The App Store" onClick={() => this.openStore(this.props.url)} />;
                break;
            case "huawei":
                tag= <img src={DownloadHuaweiButton} alt="Download On AppGallery" onClick={() => this.openStore(this.props.url)} />;
                break;
            case "facebook":
                tag= <img src={PlayFacebookButton} alt="Play On Facebook!" onClick={() => this.openStore(this.props.url)} />;
                break;
            case "web":
                tag= <img src={PlayButton} alt="Play!" onClick={() => this.openStore(this.props.url)} />;
                break;    
            default:
                tag= <img src={DownloadAndroidButton} alt="Get It On Google Play" onClick={() => this.openStore(this.props.url)} />;
                break;
        }

        return tag;
    }

    componentWillMount() {
        
    }


    render() {
        return (
            this.caseButtons()
        );
    }
}

export default AppPageStores;



// WEBPACK FOOTER //
// ./src/componentes/AppPageStores.js